(ns teamoesterreich.user-mode.ui-helper.stars
  (:require
    [clojure.string]
    [reagent-material-ui.icons.star :refer [star]]
    [reagent-material-ui.icons.star-border :refer [star-border]]
    [reagent-material-ui.icons.star-half :refer [star-half]]
    ))




(defn full-star [] [star {:style {:width "16px" :height "16px" :color "#02350"}}])
(defn no-star [] [star-border {:style {:width "16px" :height "16px" :color "#02350"}}])
(defn half-star [] [star-half {:style {:width "16px" :height "16px" :color "#02350"}}])


(defn full-star-big [] [star {:style {:width "32px" :height "32px" :color "#02350"}}])
(defn no-star-big [] [star-border {:style {:width "32px" :height "32px" :color "#02350"}}])
(defn half-star-big [] [star-half {:style {:width "32px" :height "32px" :color "#02350"}}])



(defn five-stars [value]
  (let [half (if (> (float value) (int value)) 1 0)
        full (if (number? value) (int value) 0)]
    [:div {:value value}
     (for [i (range full)] ^{:key (str "full_star " i)} [full-star {:key (str "full_star " i)}])
     (when (pos? half) [half-star])
     (for [i (range (- 5 half full))] ^{:key (str "empty_star " i)} [no-star {:key (str "empty_star " i)}])]))

;value should be 0.5 steps
(defn five-stars-big [value]
  (let [half (if (> (float value) (int value)) 1 0)
        full (if (number? value) (int value) 0)]
    [:div {:value value}
     (for [i (range full)] ^{:key (str "full_star " i)} [full-star-big {:key (str "full_star " i)}])
     (when (pos? half) [half-star])
     (for [i (range (- 5 half full))] ^{:key (str "empty_star " i)} [no-star-big {:key (str "empty_star " i)}])]))
